import React from "react";

const FALLBACK_COORDS = [85.8245, 20.2961]; // Bhubaneswar fallback [lng, lat]

const MapEmbed = ({ address, coordinates, className }) => {
  let finalCoords = null;

  if (coordinates && coordinates.length === 2) {
    const [lng, lat] = coordinates;

    if (!isNaN(lat) && !isNaN(lng)) {
      finalCoords = [lng, lat];
    }
  }

  let mapUrl = "";

  if (finalCoords) {
    const [lng, lat] = finalCoords;
    mapUrl = `https://www.google.com/maps?q=${lat},${lng}&z=16&output=embed`;
  } else if (address) {
    const encodedAddress = encodeURIComponent(address);
    mapUrl = `https://www.google.com/maps?q=${encodedAddress}&z=16&output=embed`;
  } else {
    // Apply fallback to Bhubaneswar
    const [lng, lat] = FALLBACK_COORDS;
    mapUrl = `https://www.google.com/maps?q=${lat},${lng}&z=16&output=embed`;
  }

  return (
    <div
      className={`w-full flex-1 relative rounded-lg overflow-hidden shadow-sm ${className}`}
    >
      <iframe
        src={mapUrl}
        title="Property Location"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        className="absolute top-0 left-0 w-full h-full"
      ></iframe>
    </div>
  );
};

export default MapEmbed;
